const React = require('react');
const ReactDOM = require('react-dom');
const { createElement: h, useState, useEffect } = React;
require('./WizardIntroModal.css');

// One-time "how to" intro shown over the empty canvas on a user's first visit.
// A small multi-step wizard: each step shows a screenshot + a short caption,
// "Next" advances, and the final step's "I Got it" dismisses it for good.
// Dismissal is remembered in localStorage (see STORAGE_KEY) so it never
// re-appears. NOT a native popup — reuses the shared .cdialog-* overlay shell.

const STORAGE_KEY = 'alleflow_wizard_intro_seen';

// The tips, in order. Images live in app/public/wizard_intro_how_to/ and are
// served from the site root, so paths are root-relative.
const STEPS = [
  {
    img: '/wizard_intro_how_to/edit_node.png',
    title: 'Edit a node',
    caption: 'Click any node on the canvas to open its editor and configure what it does.'
  },
  {
    img: '/wizard_intro_how_to/doubleclikc_to_manage_node_params.png',
    title: 'Manage node parameters',
    caption: 'Click a node parameter to open it and fine-tune its inputs.'
  },
  {
    img: '/wizard_intro_how_to/insert_node_in_between.png',
    title: 'Insert a node in between',
    caption: 'Hover a connector between two nodes and click to drop a new node right in the middle.'
  },
  {
    img: '/wizard_intro_how_to/view_node_output.png',
    title: 'View node output',
    caption: 'After a run, open a node to inspect the exact data it produced.'
  },
  {
    img: '/wizard_intro_how_to/turn_on_debugger.png',
    title: 'Turn on the debugger',
    caption: 'Flip the debugger on to step through your workflow and catch issues as they happen.'
  },
  {
    img: '/wizard_intro_how_to/mouse_hover_to_variable_to_see_what_nodes_using_it.png',
    title: 'Trace your variables',
    caption: 'Hover a variable to highlight every node that reads or writes it.'
  }
];

// Whether the intro has already been dismissed. Guarded so a blocked/absent
// localStorage (private mode, etc.) simply shows the intro rather than throwing.
function hasSeenWizardIntro() {
  try { return window.localStorage.getItem(STORAGE_KEY) === '1'; }
  catch (e) { return false; }
}

function markWizardIntroSeen() {
  try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
}

function WizardIntroModal(props) {
  var onClose = props.onClose || function() {};
  var [index, setIndex] = useState(0);

  var isLast = index >= STEPS.length - 1;
  var step = STEPS[index];

  useEffect(function() {
    function onKeyDown(e) { if (e.key === 'Escape') finish(); }
    document.addEventListener('keydown', onKeyDown);
    return function() { document.removeEventListener('keydown', onKeyDown); };
  }, []);

  // Persist the "seen" flag and close, regardless of which step we exit from —
  // dismissing early still counts as seen so it doesn't nag on the next visit.
  function finish() {
    markWizardIntroSeen();
    onClose();
  }

  function next() {
    if (isLast) { finish(); return; }
    setIndex(function(i) { return i + 1; });
  }

  var content = h('div', { className: 'cdialog-overlay wiz-overlay', onMouseDown: finish },
    h('div', {
      className: 'cdialog-box wiz-box',
      onMouseDown: function(e) { e.stopPropagation(); }
    },
      h('div', { className: 'wiz-header' },
        h('button', { className: 'wiz-skip', onClick: finish, title: 'Skip the intro' }, 'Skip')
      ),

      h('div', { className: 'wiz-image-frame' },
        h('img', { className: 'wiz-image', src: step.img, alt: step.title })
      ),

      h('div', { className: 'wiz-title' }, step.title),
      h('div', { className: 'wiz-caption' }, step.caption),

      // Progress dots so the user knows how many tips remain.
      h('div', { className: 'wiz-dots' },
        STEPS.map(function(s, i) {
          return h('span', {
            key: i,
            className: 'wiz-dot' + (i === index ? ' wiz-dot-active' : '')
          });
        })
      ),

      h('div', { className: 'wiz-actions' },
        h('button', { className: 'wiz-next-btn', onClick: next },
          isLast ? 'I Got it' : 'Next'
        )
      )
    )
  );

  if (typeof document !== 'undefined' && document.body && ReactDOM && ReactDOM.createPortal) {
    return ReactDOM.createPortal(content, document.body);
  }
  return content;
}

WizardIntroModal.hasSeenWizardIntro = hasSeenWizardIntro;
WizardIntroModal.markWizardIntroSeen = markWizardIntroSeen;
module.exports = WizardIntroModal;
